<template>
    <v-autocomplete
        v-model="item"
        :items="results"
        :loading="isLoading"
        :search-input.sync="search"
        hide-no-data
        hide-selected
        item-text="itemId"
        label="Part Numbers"
        placeholder="Start typing to Search"
        prepend-icon="mdi-database-search"
        return-object
        value="itemId"
    ></v-autocomplete>
</template>

<script>
  export default {
    data() {
      return {
        isLoading: false,
        count: 0,
        search: null,
        results: [],
        item: 'N7K-SUP2E',
      }
    },
    props: ['itemId'],
    computed: {
    },
    methods: {

    },
    watch: {
      item(value) {
        console.log('watch item', value);
        if (value) this.$emit('input', value.itemId);
      },
      search (value) {
        console.log('search::value', value);
        // Items have already been loaded
        if (this.results && this.results.length > 0) return;

        // Items have already been requested
        if (this.isLoading) return;

        this.isLoading = true;

        this.results = this.$store.state.partNumbers;

        this.isLoading = false;
      }
    }
  }
</script>
